export default "__VITE_ASSET__d51692ee__"